<template>
  <div
    class="flex flex-col w-full"
    style="
      /* height: calc(100vh - 3.5rem);
      overflow: scroll; */
      padding-bottom: 100px;
    "
    :class="`3xl:w-${widthClass} lg:p-${padding} lg:pl-${paddingX} lg:pr-${paddingX}`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContentContainer',
  props: {
    widthClass: {
      type: String,
      default: '8/12',
    },
    padding: {
      type: String,
      default: '10',
    },
    paddingX: {
      type: String,
      default: '16',
    },
  },
}
</script>
